module.exports = __webpack_public_path__ + "static/media/404-desktop.3500c07e.svg";